import React, { createContext, useContext, useState, useEffect } from 'react';
import { authClient } from '../lib/authClient';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    // Consume any auth tokens left in the URL hash by email-confirmation or
    // password-recovery redirects. Idempotent and safe to call on every boot.
    try { authClient.consumeHashSession(); } catch (_) { /* ignore */ }

    authClient.getSession().then((current) => {
      if (cancelled) return;
      setSession(current);
      setLoading(false);
    }).catch(() => {
      if (cancelled) return;
      setSession(null);
      setLoading(false);
    });

    // Listen for auth changes (sign in, sign out, token refresh, cross-tab).
    const { data: { subscription } } = authClient.onAuthStateChange(
      (_event, nextSession) => {
        setSession(nextSession);
        setLoading(false);
      }
    );

    return () => {
      cancelled = true;
      subscription.unsubscribe();
    };
  }, []);

  const value = {
    session,
    user: session?.user ?? null,
    isAuthenticated: !!session,
    loading,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
